/**
 * MessageStatusTicks
 *
 * Shows message delivery status:
 * - sending: clock icon
 * - sent: single check
 * - delivered: double check
 * - read: double check (blue/primary)
 */

import { CheckIcon, ClockIcon } from '@heroicons/react/24/outline';

export default function MessageStatusTicks({ status, isOwn }) {
  if (!status) return null;

  const color = isOwn ? 'text-primary-content/50' : 'text-base-content/40';
  const readColor = isOwn ? 'text-primary-content/70' : 'text-primary';

  switch (status) {
    case 'sending':
      return <ClockIcon className={`w-3 h-3 ${color}`} />;
    case 'sent':
      return <CheckIcon className={`w-3 h-3 ${color}`} />;
    case 'delivered':
      return (
        <span className="relative inline-flex">
          <CheckIcon className={`w-3 h-3 ${color}`} />
          <CheckIcon className={`w-3 h-3 ${color} -ml-1.5`} />
        </span>
      );
    case 'read':
      return (
        <span className="relative inline-flex">
          <CheckIcon className={`w-3 h-3 ${readColor}`} />
          <CheckIcon className={`w-3 h-3 ${readColor} -ml-1.5`} />
        </span>
      );
    default:
      return null;
  }
}
